import aTemps from './assets/songs/Lexil - À temps.mp3'
import caseDepart from './assets/songs/Lexil - Case départ.mp3'
import onwards from './assets/songs/Player 2 - Onwards.mp3'
import giveMe from './assets/songs/Versus me - Give me One Reason.wav'
import weCouldBeHeroes from './assets/songs/We Could Be Heroes - Conway.mp3'
import trouBlanc from './assets/songs/Lexil - Trou blanc.mp3'

import sab from './assets/sab-work.webp'

export default [
	{
		title: 'À temps',
		artist: 'Lexil',
		audioSrc: aTemps,
		image: sab,
		color: '#00aeb0',
		length: '4:14',
	},
	{
		title: 'Case Départ',
		artist: 'Lexil',
		audioSrc: caseDepart,
		image: sab,
		color: '#00aeb0',
		length: '6:11',
	},
	{
		title: 'Onwards',
		artist: 'Player 2',
		audioSrc: onwards,
		image: sab,
		color: '#00aeb0',
		length: '4:36',
	},
	{
		title: 'Give me a Reason',
		artist: 'Versus Me',
		audioSrc: giveMe,
		image: sab,
		color: '#00aeb0',
		length: '3:55',
	},
	{
		title: 'Trou Blanc',
		artist: 'Lexil',
		audioSrc: trouBlanc,
		image: sab,
		color: '#00aeb0',
		length: '3:36',
	},
	{
		title: 'We Could be Heroes',
		artist: 'Conway',
		audioSrc: weCouldBeHeroes,
		image: sab,
		color: '#00aeb0',
		length: '3:51',
	},
]
